/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
import { Box, TableCell, TableRow, Tooltip } from "@mui/material";
import React from "react";
import { Moving } from "@mui/icons-material";
import tableStyle from "../../theme/styles/table";
import { isEmptyObj } from "../../utils/helper";
import Button from "../common/Button";
import { style, tabelCellWidth } from "./styles";
import { PERMISSIONS } from "../../contants";

function AppointmentSecondApprovalApplication({
  member,
  currentUserId,
  onMemberSelect,
  hasPermission,
  onForcePushApplication,
}) {
  if (isEmptyObj(member) || isEmptyObj(member.memberDetails)) {
    return null;
  }

  const currentUserVoter = member?.voters?.find(
    (voter) => Number(voter?.voterMember?.memberId) === Number(currentUserId)
  );

  const isReviewReady = currentUserVoter?.status === "COMPLETED";

  return (
    <TableRow style={tableStyle.tableRow}>
      <TableCell style={{ ...style.Cell, color: "#043D90", fontWeight: "600" }}>
        {member.memberDetails.memberId}
      </TableCell>

      <TableCell style={style.Cell}>
        {member.memberDetails.fullName || "-"}
        <br />
        {member.memberDetails.addressLine1 || "-"}
      </TableCell>

      <TableCell style={style.Cell}>
        {member.memberDetails.mobileNumber || "-"}
        <br />
        {member.memberDetails.emailId || "-"}
      </TableCell>

      <TableCell style={style.Cell}>
        {member.memberDetails.divisionName || "-"}
      </TableCell>

      <TableCell style={{ ...style.Cell, ...tabelCellWidth.medium }}>
        {member.structureLevel === "BLOCK"
          ? [
              member?.memberDetails?.areaName,
              member?.memberDetails?.clusterName,
              member?.memberDetails?.zoneName,
              member?.memberDetails?.regionName,
              member?.memberDetails?.chapterName,
              member?.memberDetails?.districtName,
              member?.memberDetails?.blockName,
            ]
              .filter(Boolean)
              .join("/ ")
          : member.structureLevel === "DISTRICT"
          ? [
              member?.memberDetails?.areaName,
              member?.memberDetails?.clusterName,
              member?.memberDetails?.zoneName,
              member?.memberDetails?.regionName,
              member?.memberDetails?.chapterName,
              member?.memberDetails?.districtName,
            ]
              .filter(Boolean)
              .join("/ ")
          : member.structureLevel === "CHAPTER"
          ? [
              member?.memberDetails?.areaName,
              member?.memberDetails?.clusterName,
              member?.memberDetails?.zoneName,
              member?.memberDetails?.regionName,
              member?.memberDetails?.chapterName,
            ]
              .filter(Boolean)
              .join("/ ")
          : member.structureLevel === "REGION"
          ? [
              member?.memberDetails?.areaName,
              member?.memberDetails?.clusterName,
              member?.memberDetails?.zoneName,
              member?.memberDetails?.regionName,
            ]
              .filter(Boolean)
              .join("/ ")
          : member.structureLevel === "ZONE"
          ? [
              member?.memberDetails?.areaName,
              member?.memberDetails?.clusterName,
              member?.memberDetails?.zoneName,
            ]
              .filter(Boolean)
              .join("/ ")
          : member.structureLevel === "CLUSTER"
          ? [
              member?.memberDetails?.areaName,
              member?.memberDetails?.clusterName,
            ]
              .filter(Boolean)
              .join("/ ")
          : [member?.memberDetails?.areaName].filter(Boolean).join("/ ")}
      </TableCell>

      <TableCell style={style.Cell}>{member.appliedForName || "NA"}</TableCell>

      <TableCell style={{ color: "#8C8C8C" }}>
        <Box style={{ ...style.flexC, gap: "10px" }}>
          <Box style={{ ...style.ActionBtnContainer }}>
            <Button
              onClick={() =>
                onMemberSelect(member.memberDetails.memberId, "recommended2")
              }
              style={{
                ...style.actionBtn,
                ...(isReviewReady
                  ? {
                      color: "#fff",
                      border: "1px solid #2e7d32",
                      backgroundColor: "#2e7d32",
                    }
                  : {}),
              }}
              label="REVIEW"
              variant="outlined"
            />
          </Box>

          {hasPermission(PERMISSIONS.FORCE_PUSH_APPLICATION) && (
            <Tooltip title="Force Push">
              <Box
                style={{
                  padding: "2px 4px 0px 4px",
                  border: "1px solid",
                  borderRadius: "4px",
                  height: "30px",
                }}
              >
                <Moving
                  style={{ ...style.actionIcon }}
                  onClick={() => onForcePushApplication(member, "forcepush")}
                />
              </Box>
            </Tooltip>
          )}
        </Box>
      </TableCell>
    </TableRow>
  );
}

export default AppointmentSecondApprovalApplication;
